import {
	BASE,
	WIKI,
	HOME,
	SPACE_INDEX,
	SPACE_OVERVIEW,
	VIEW_BLOG,
	VIEW_BLOG_DATE_LEGACY,
	WHITEBOARD_BOARD,
	VIEW_PAGE,
	EDIT_PAGE_V2,
	EDIT_BLOG_V2,
	EDIT_PAGE_EMBED,
	EDIT_PAGE_SMART_CREATE,
	EXTERNAL_SHARE,
	ACCESS_LINK,
	SPACE_PAGES,
	CONTENT_HISTORY,
	CREATE_CONTENT,
	DATABASE_VIEW,
	EMBED_VIEW,
	COMPANY_HUB,
	COMPANY_HUB_EDIT,
	HUB_EDIT,
	PDF_EXPORT_PAGE,
	ADVANCED_SEARCH,
	ATTACHMENTS_PAGE,
} from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getCachedPageData } from '@confluence/live-pages-utils/entry-points/getCachedPageData.ts';

export const matchHome: (url: string) => RouteMatch | null = (url: string) =>
	BASE.match(url) || WIKI.match(url) || HOME.match(url);

export const matchLivePage: (url: string) => RouteMatch | null = (url: string) => {
	const viewMatch = VIEW_PAGE.match(url);
	const contentId = viewMatch?.params?.contentId;
	if (contentId) {
		const { subType, isArchived } = getCachedPageData(contentId);
		if (subType === 'live' && !isArchived) {
			return viewMatch;
		}
	}
	return null;
};

export const matchViewPage: (url: string) => RouteMatch | null = (url: string) => {
	return VIEW_PAGE.match(url) || matchBlogPage(url);
};

export const matchBlogPage: (url: string) => RouteMatch | null = (url: string) =>
	VIEW_BLOG.match(url) || VIEW_BLOG_DATE_LEGACY.match(url);

export const matchWhiteboardPage: (url: string) => RouteMatch | null = (url: string) =>
	WHITEBOARD_BOARD.match(url);

export const matchDatabasePage: (url: string) => RouteMatch | null = (url: string) =>
	DATABASE_VIEW.match(url);

export const matchEmbedPage: (url: string) => RouteMatch | null = (url: string) =>
	EMBED_VIEW.match(url);

export const matchSpaceOverview: (url: string) => RouteMatch | null = (url: string) =>
	SPACE_OVERVIEW.match(url) || SPACE_INDEX.match(url);

export const matchCompanyHub: (url: string) => RouteMatch | null = (url: string) =>
	COMPANY_HUB.match(url);

export const matchFabricEditor: (url: string) => RouteMatch | null = (url: string) =>
	EDIT_PAGE_V2.match(url) ||
	EDIT_BLOG_V2.match(url) ||
	COMPANY_HUB_EDIT.match(url) ||
	HUB_EDIT.match(url);

export const matchEditBlog: (url: string) => RouteMatch | null = (url: string) =>
	EDIT_BLOG_V2.match(url);

export const matchExternalShare: (url: string) => RouteMatch | null = (url: string) =>
	EXTERNAL_SHARE.match(url);

export const matchAccessLink: (url: string) => RouteMatch | null = (url: string) =>
	ACCESS_LINK.match(url);

export const matchSpacePages: (url: string) => RouteMatch | null = (url: string) =>
	SPACE_PAGES.match(url);

export const matchContentHistory: (url: string) => RouteMatch | null = (url: string) =>
	CONTENT_HISTORY.match(url);

export const matchAttachmentsPage: (url: string) => RouteMatch | null = (url: string) =>
	ATTACHMENTS_PAGE.match(url);

export const matchEmbeddedEditor: (url: string) => RouteMatch | null = (url: string) =>
	EDIT_PAGE_EMBED.match(url);

export const matchSmartCreateEditor: (url: string) => RouteMatch | null = (url: string) =>
	EDIT_PAGE_SMART_CREATE.match(url);

export const matchCreateContent: (url: string) => RouteMatch | null = (url: string) =>
	CREATE_CONTENT.match(url);

export const matchPdfExport: (url: string) => RouteMatch | null = (url: string) =>
	PDF_EXPORT_PAGE.match(url);

export const matchSearch: (url: string) => RouteMatch | null = (url: string) =>
	ADVANCED_SEARCH.match(url);
